module.exports = __webpack_public_path__ + "img/drawer-background.705554aa.png";